<hpf-image-form
        *ngIf="image"
        [image]="image"
        (create)="onCreate($event)"
    ></hpf-image-form>
<div *ngIf="!image" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>